// extracted by mini-css-extract-plugin
module.exports = {"title":"mf-lm"};